<template>
  <div class="animation-wrapper">
		<div class="water">
			<ul class="waves">
				<li class="wave-one" style="background-image: url('/static/img/water.svg');"></li>
				<li class="wave-two" style="background-image: url('/static/img/water2.svg');"></li>
			</ul>
		</div>
		<div class="boat" style="background-image:  url('/static/img/boat.svg');"></div>
	</div>
</template>
<script>
export default {
  name: 'sailboat'
}
</script>
<style lang="scss" scoped>

.animation-wrapper{
	position: relative;
  width:10em;
  height: 4em;
  margin: auto;
  overflow: hidden;
  border-radius: 30%;
}

.water{
  bottom: 0;
  left: 0;
  right: 0;
	position: absolute;
  width: 100%;
}

.water ul.waves{
	list-style: none;
	margin: 0;
	padding: 0;
}

.water ul.waves li{
	background-repeat: repeat-x;
}

.water ul.waves li.wave-one{
	animation: wave 12s linear infinite;
	-webkit-animation-fill-mode: forwards;
	-o-animation-fill-mode: forwards;
	animation-fill-mode: forwards;
	height: .7em;
	position: absolute;
  bottom: .1em;
	z-index: 10;
  left: 0;
	right: 0;
  background-size: contain;
}

.water ul.waves li.wave-two{
	-webkit-animation-fill-mode: forwards;
	-o-animation-fill-mode: forwards;
	animation-fill-mode: forwards;
	animation: wave 25s linear infinite;
  background-size: contain;
	bottom: .8em;
	height: .5em;
	position: absolute;
	left: 0;
	right: 0;
	z-index: 0;
}


.boat{
	animation: boat 3s linear infinite;
    background-repeat: no-repeat;
    background-size: contain;
    bottom: 0;
    height: 4em;
    width: 4em;
    right: 1em;
	  position: absolute;
}



/*Animation Keyframe Section*/

@keyframes wave{
    0% {
        background-position: 0 0;
	}

    100% {
        background-position: -15em 0;
    }
}

@keyframes boat{
	0%{
		transform: rotate(0);
	}

	50%{
		transform: rotate(-10deg);
	}

	100%{
		transform: rotate(0);
	}
}
</style>


// WEBPACK FOOTER //
// src/components/product/SailBoatAnimation.vue